import React from 'react';

/**
 * Card — the base surface (spec §4). Soft shadow + 1px inset hairline, lifts on hover.
 * `as` lets callers render a section/article; `hover={false}` opts out of the lift.
 */
const Card = ({ as: Tag = 'div', hover = true, className = '', children, ...props }) => (
  <Tag
    className={[
      'bg-arc-card rounded-arc-card p-[22px] shadow-arc-sm ring-1 ring-arc-line',
      hover
        ? 'transition-all duration-150 hover:-translate-y-[3px] hover:shadow-arc-md hover:ring-arc-line-2'
        : '',
      className,
    ].join(' ')}
    {...props}
  >
    {children}
  </Tag>
);

export default Card;
